import { useState } from "react";

const projects = [
  {
    img: "https://static.prod-images.emergentagent.com/jobs/e88f9df8-0827-4de8-b395-30b21dfa42d4/images/5e1113cc58b5efecab2805750ddbee5db3ce3a849502b57e653e07acf916750d.png",
    title: "The Quiet Bedroom",
    meta: "4-Room BTO · Punggol",
    cat: "BTO",
    h: "tall",
  },
  {
    img: "https://images.unsplash.com/photo-1759238136818-7b00ec9e782a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxtaW5pbWFsaXN0JTIwbHV4dXJ5JTIwbGl2aW5nJTIwcm9vbSUyMGFwYXJ0bWVudCUyMGludGVyaW9yfGVufDB8fHx8MTc3OTM3ODIyNXww&ixlib=rb-4.1.0&q=85",
    title: "Soft Editorial Living",
    meta: "5-Room Resale · Tampines",
    cat: "Resale",
    h: "short",
  },
  {
    img: "https://images.unsplash.com/photo-1765371514650-1f99696ca69f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBraXRjaGVuJTIwcmVub3ZhdGlvbiUyMHdhcm0lMjBsaWdodGluZ3xlbnwwfHx8fDE3NzkzNzgyMjV8MA&ixlib=rb-4.1.0&q=85",
    title: "Warm Kitchen, Stone Counter",
    meta: "4-Room BTO · Tengah",
    cat: "BTO",
    h: "short",
  },
  {
    img: "https://images.pexels.com/photos/8135496/pexels-photo-8135496.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "Open Plan, Open Heart",
    meta: "5-Room Resale · Bishan",
    cat: "Resale",
    h: "tall",
  },
  {
    img: "https://customer-assets.emergentagent.com/job_dream-home-sg/artifacts/875f8eej_images-5.jpeg",
    title: "Soft Terracotta Hallway",
    meta: "3-Room Resale · Toa Payoh",
    cat: "Resale",
    h: "short",
  },
  {
    img: "https://customer-assets.emergentagent.com/job_dream-home-sg/artifacts/yqliob9f_Healthier_Living_HDB_BTO_3-Room_Renovation_Tips_480x480.webp",
    title: "Bathing in Daylight",
    meta: "4-Room BTO · Sengkang",
    cat: "BTO",
    h: "tall",
  },
];

const filters = ["All", "BTO", "Resale"];

export const Portfolio = () => {
  const [filter, setFilter] = useState("All");
  const items = filter === "All" ? projects : projects.filter((p) => p.cat === filter);

  return (
    <section
      id="portfolio"
      data-testid="portfolio-section"
      className="relative bg-[color:var(--nr-bg)] py-24 md:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14 reveal">
          <div>
            <p className="overline mb-5">Selected works</p>
            <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.02] text-[color:var(--nr-ink)]">
              Recent{" "}
              <em className="italic font-light text-[color:var(--nr-accent)]">
                homes
              </em>{" "}
              we've quietly transformed.
            </h2>
          </div>
          <div className="flex gap-2" data-testid="portfolio-filters">
            {filters.map((f) => (
              <button
                key={f}
                data-testid={`portfolio-filter-${f.toLowerCase()}`}
                onClick={() => setFilter(f)}
                className={`px-5 py-2.5 rounded-full text-xs uppercase tracking-[0.2em] font-semibold border transition-all duration-300 ${
                  filter === f
                    ? "bg-[color:var(--nr-ink)] text-white border-[color:var(--nr-ink)]"
                    : "bg-transparent text-[color:var(--nr-ink)] border-[color:var(--nr-line)] hover:bg-[color:var(--nr-bg-soft)]"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {items.map((p, i) => (
            <figure
              key={p.title + i}
              data-testid={`portfolio-item-${i}`}
              className={`reveal group relative overflow-hidden rounded-xl bg-[color:var(--nr-bg-soft)] ${
                p.h === "tall" ? "lg:row-span-2 aspect-[3/4] lg:aspect-[3/4.4]" : "aspect-[4/3]"
              }`}
            >
              <img
                src={p.img}
                alt={p.title}
                className="absolute inset-0 w-full h-full object-cover tile-img"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/10 to-transparent opacity-90" />
              <figcaption className="absolute bottom-0 left-0 right-0 p-6 lg:p-7 text-white">
                <div className="text-[0.65rem] uppercase tracking-[0.24em] text-white/80">
                  {p.cat}
                </div>
                <div className="font-serif-display text-2xl lg:text-3xl mt-1 leading-tight">
                  {p.title}
                </div>
                <div className="text-sm text-white/80 mt-1">{p.meta}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
